import { AppShell } from '../components/AppShell';
import { GroceriesCard } from '../components/groceries/GroceriesCard';
import { ExpiringSoonCard } from '../components/pantry/ExpiringSoonCard';
import { RemindersCard } from '../components/plans/RemindersCard';
import { TonightHero } from '../components/plans/TonightHero';
import { UpcomingMealsCard } from '../components/plans/UpcomingMealsCard';
import { ServerStatus } from '../components/ServerStatus';
import { useAuth } from '../lib/auth';

export function DashboardPage() {
  const { auth } = useAuth();
  const user = auth.status === 'authed' ? auth.user : null;
  const household = auth.status === 'authed' ? auth.household : null;
  return (
    <AppShell width="wide">
      <div className="flex flex-col gap-6">
        <TonightHero
          firstName={user ? (user.displayName.split(' ')[0] ?? null) : null}
          household={household?.name ?? null}
        />
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-3">
          <div className="flex flex-col gap-5 xl:col-span-2">
            <RemindersCard />
            <UpcomingMealsCard limit={5} />
          </div>
          <div className="flex flex-col gap-5">
            <GroceriesCard />
            <ExpiringSoonCard />
            <ServerStatus />
          </div>
        </div>
      </div>
    </AppShell>
  );
}
